import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=dfc0a6b0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=dfc0a6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc0a6b0",
  null
  
)

export default component.exports